const ITEMS = [
  "KAUPAPA MĀORI",
  "KĀWHIA PROVENANCE",
  "BOTANICAL PRECISION",
  "EST. 2026",
  "SUSTAINABLE CULTIVATION",
  "DOCUMENTED GENETICS",
  "RANGATAHI PATHWAYS",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-serif-brand italic text-2xl sm:text-3xl lg:text-4xl text-[#A3B899]/70 whitespace-nowrap px-8">
          {item}
        </span>
        <svg viewBox="0 0 12 12" className="w-2.5 h-2.5 text-[#D4A359]/70 shrink-0" fill="currentColor" aria-hidden="true">
          <circle cx="6" cy="6" r="6" />
        </svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="relative overflow-hidden bg-[#121512] border-y border-[#FBF9F4]/8 py-7 sm:py-9" data-testid="editorial-marquee">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
